import React, { Component } from "react";
import BuyerPreferences from "../../components/Preferences/BuyerPreferences";

class Preferences extends Component {
    render(){
        return(
            <BuyerPreferences/>
        )
    }
}
export default Preferences